module.exports = __webpack_public_path__ + "img/gift3.467d9f77.png";